import { createMuiTheme } from "@material-ui/core";
import { red, purple } from "@material-ui/core/colors";

export const primary = purple;
export const secondary = red;

export const theme = createMuiTheme({
  palette: { primary, secondary },
});
